<template>
  <div class="login">
    <div class="header">
      <div class="nav">
        <img src="@/assets/logo.png" class="logImg" />
        <div class="right">
          <img src="@/assets/row.png" />
        </div>
      </div>
    </div>

    <div class="login-from">
      <el-button-group class="btn-group">
        <el-button
          @click="handleClick('BFP')"
          :type="activeName === 'BFP' ? 'primary' : ''"
          size="mini"
          class="btn-item"
          >BFP系统</el-button
        >
        <el-button
          @click="handleClick('CAS')"
          :type="activeName === 'CAS' ? 'primary' : ''"
          size="mini"
          class="btn-item"
          >CAS系统</el-button
        >
      </el-button-group>

      <p class="title">Login | 登录</p>

      <login-input
        type="text"
        v-model="ruleForm.phone"
        auto-complete="off"
        placeholder="请输入用户名"
        :clazz="res.phone"
        @blur="inputBlur('phone')"
        @keyup.enter.native="handleSubmit"
      >
        <div class="input-prefix__icon">
          <img class="input-prefix-icon" src="@/assets/user.png" alt />
        </div>
      </login-input>
      <login-input
        type="password"
        v-model="ruleForm.password"
        auto-complete="off"
        placeholder="请输入密码"
        :clazz="res.password"
        @blur="inputBlur('password')"
        @keyup.enter.native="handleSubmit"
      >
        <div class="input-prefix__icon">
          <img class="input-prefix-icon" src="@/assets/pwd.png" alt />
        </div>
      </login-input>
      <!-- <login-input
        type="text"
        v-model="ruleForm.secCode"
        auto-complete="off"
        placeholder="请输入二次验证码"
        :clazz="res.secCode"
        :maxlength="7"
        @blur="inputBlur('secCode')"
        @keyup.enter.native="handleSubmit"
        @keyup="bankCardKeyup"
      >
        <div class="input-prefix__icon">
          <img class="input-prefix-icon" src="@/assets/pwd.png" alt />
        </div>
      </login-input> -->
      <login-input
        type="text"
        v-model="ruleForm.code"
        auto-complete="off"
        placeholder="请输入手机验证码"
        :clazz="res.code"
        :maxlength="7"
        :bool="true"
        :phone="ruleForm.phone"
        @blur="inputBlur('code')"
        @keyup.enter.native="handleSubmit"
        @keyup="bankCardKeyup"
      >
        <div class="input-prefix__icon">
          <img class="input-prefix-icon" src="@/assets/key.png" alt />
        </div>
      </login-input>
      <div class="action-buttons">
        <el-button
          class="action-button blue"
          @click="handleSubmit"
          :loading="showLogining"
          >进入</el-button
        >
      </div>

      <div class="copyright">技术归属盈众商保-版本号:V2.0.2.1.v</div>
    </div>

    <div class="footer">
      <p>Copyright ©2017-2020 YZ Commercial Factoring, All Rights Reserved</p>
      <p>系统最佳浏览器:Google Chrome 闽ICP备18026435号-4</p>
      <p style="margin-top: 10px">
        Has obtained the authorization of CAS for business instructions, and the
        authorization deadline is 2022.
      </p>
      <p>已经获得CAS授权，有效期为2022年</p>
    </div>
  </div>
</template>

<script>
import regexps from '@/utils/regexps'
import { getToken, setToken, setUserInfo } from '@/utils/auth'
import LoginInput from './components/LoginInput'
import router from '@/router'
import request from '@/plugins/http'
import qs from 'qs'

export default {
  beforeRouteEnter(to, form, next) {
    // debugger
    next(self => {
      // 如果已经登录过 那么跳转回默认页面
      if (getToken()) {
        router.replace('/home')
      }
    })
  },

  components: {
    LoginInput
  },

  data() {
    return {
      show: false,
      notCheck: false, // 是否不需要登录直接进入
      tabPosition: 'left',
      activeName: 'BFP',
      res: {
        phone: false,
        password: false,
        secCode: false,
        code: false
      },
      ruleForm: {
        phone: '',
        password: '',
        secCode: '',
        code: ''
      },
      // 校验规则 请输入用户名 请输入密码 请再次输入通行秘钥
      rules: {
        phone: [{ required: false, message: '', trigger: 'blur' }],
        password: [{ required: false, message: '', trigger: 'blur' }],
        secCode: [{ required: false, message: '', trigger: 'blur' }],
        code: [{ required: false, message: '', trigger: 'blur' }]
      },
      showLogining: false,
      showNotify: null
    }
  },

  methods: {
    inputBlur(key) {
      if (!this.ruleForm[key]) {
        this.res[key] = true
      } else {
        this.res[key] = false
      }
    },
    handleClick(val) {
      this.activeName = val
    },
    bankCardKeyup(e) {
      let { secCode } = this.ruleForm
      this.ruleForm.secCode = secCode
        .replace(/\s/g, '')
        .replace(/[^\d]/g, '')
        .replace(/(\d{3})(?=\d)/g, '$1 ')
    },

    // 用户请求登录
    async handleSubmit() {
      const {
        $notify,
        activeName,
        $store: { dispatch },
        ruleForm: { phone, password, secCode, code }
      } = this
      let secretKey = secCode.replace(/\s+/g, '')

      // 启用后不用请求就可以进入页面
      if (this.notCheck) {
        setToken(phone)
        localStorage.clear()
        // 存入用户数据，成功后跳转路由
        this.showLogining = true
        dispatch('userInfo', { companyId: 'a3636' }).then(res => {
          this.$router.replace('/home')
          this.loading = false
        })
        return false
      }

      // 防止出现过多弹窗
      if (this.showNotify) {
        this.showNotify.close()
      }

      if (!regexps.phone.test(phone)) {
        this.showNotify = $notify.error({
          title: '提示',
          message: '用户手机格式错误！',
          duration: 3 * 1000
        })
        return false
      }
      // else if (
      //   !/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,16}$/.exec(password) &&
      //   !/\d{6}/.test(password)
      // ) {
      //   this.showNotify = $notify.error({
      //     title: '提示',
      //     message: '密码格式错误！',
      //     duration: 3 * 1000
      //   })
      //   return false
      // }
      else if (!/\d{6}/.test(secretKey) && !/\d{6}/.test(code)) {
        this.showNotify = $notify.error({
          title: '提示',
          message: '验证码格式错误！',
          duration: 3 * 1000
        })
        return false
      }
      // else if (!/\d{6}/.test(code)) {
      //   this.showNotify = $notify.error({
      //     title: '提示',
      //     message: '验证码格式错误！',
      //     duration: 3 * 1000
      //   })
      //   return false
      // }

      // 判断登录数据为空则设置 placeholder 变红
      if (!phone || !password || !secCode || !code) {
        for (let key in this.ruleForm) {
          this.res[key] = !this.ruleForm[key]
        }
      }

      this.showLogining = true

      // 登录BFP系统
      if (activeName === 'BFP') {
        console.log('bfp')
        dispatch('login/formalLogin', {
          phone,
          password,
          secCode: secretKey,
          code
        }).then(res => {
          if (res && res.status === 200) {
            setToken(phone)
            // 存入用户数据，成功后跳转路由
            dispatch('userInfo', res.data)
              .then(res => {
                const { redirectPath } = this.$route.query
                this.$router.replace(redirectPath || '/home').catch(() => {
                  window && window.location.reload()
                  location && location.reload()
                })
                this.showLogining = false
              })
              .catch(() => {
                this.showLogining = false
              })
          } else {
            setTimeout(() => {
              this.showLogining = false
            }, 600)
          }
        })
      } else if (activeName === 'CAS') {
        // 登录CAS系统
        request
          .post(
            '/api/sys/login',
            {
              mobile: phone,
              password,
              auth: secretKey
            },
            { json: true, type: 'cas' }
          )
          .then(res => {
            if (res.status === 200) {
              setUserInfo(res.data)
              setToken(res.data.token)
              console.log(res.data)
              window.location.href = '/cas/home'
              // if (window.location.href.indexOf('demo.test2') != -1) {
              //   window.location.href = 'http://demo.test2.yzbfp.com:28888/'
              // } else if (window.location.href.indexOf('dev.test2') != -1) {
              //   window.location.href = 'http://demo.test2.yzbfp.com:28888/'
              // } else if (
              //   window.location.href.indexOf('https://www.yzbfp.com/') != -1
              // ) {
              //   window.location.href = 'https://www.yzbfp.com/'
              // } else {
              //   window.location.href = `http://10.10.66.19:8085/?token=${res.data.token}&userId=${res.data.userId}`
              // }
            }
            this.showLogining = false
          })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  position: fixed;
  top: 0;
  width: 100%;
  left: 0;
  z-index: 99;
  height: 80px;
  box-shadow: 1px 3px 9px rgba(0, 0, 0, 0.2);
  background: #fff;
  .nav {
    height: inherit;
    width: 90%;
    margin: 0 auto;
    line-height: 80px;
  }
  .logImg {
    width: 140px;
    vertical-align: middle;
    line-height: 80px;
  }
  .right {
    float: right;
    height: inherit;
    img {
      width: 40px;
      vertical-align: middle;
    }
  }
}

/* 文本表单 */
.login {
  position: relative;
  background: url('../../assets/login_bg.jpg') no-repeat;
  background-size: cover;
  overflow: hidden;
  min-height: 100vh;
}

.login-from {
  position: relative;
  width: 330px;
  margin: calc(100vh / 2 - 180px) auto 50px;
  padding: 0 26px;
  border-radius: 10px;
  border: 1px solid #dadada;
  background: rgba(255, 255, 255, 0.3);

  .btn-group {
    display: flex;
    position: absolute;
    width: 100%;
    top: -16px;
    left: 0;
    justify-content: center;
    border-radius: 6px;
    overflow: hidden;
    z-index: 98;

    .btn-item {
      width: 90px;
      height: 32px;
      margin: 0;
      border: 0;
      font-size: 14px;
      font-weight: 900;
    }

    .el-button:first-child {
      border-radius: 6px 0 0 6px;
    }

    .el-button:last-child {
      border-radius: 0 6px 6px 0;
    }
  }

  /deep/ .action-button {
    width: 98%;
    border-radius: 5px;
  }

  .copyright {
    font-size: 12px;
    color: #505050;
    margin: 30px 0 10px;
    text-align: center;
  }
}

.title {
  font-size: 15px;
  margin-top: 50px;
  margin-bottom: 30px;
  font-weight: 900;
}

.footer {
  text-align: center;
  margin: 150px 0 0;

  p {
    font-size: 12px;
  }
  img {
    width: 60px;
  }
}
</style>
